export default __webpack_public_path__ + "locales/nl/Payments.json?hash=de2f6feedea0f95d8105d28e71b1cbee";